import { render, staticRenderFns } from "./InductionDetails.vue?vue&type=template&id=35b2a27f&scoped=true&"
import script from "./InductionDetails.vue?vue&type=script&lang=js&"
export * from "./InductionDetails.vue?vue&type=script&lang=js&"
import style0 from "./InductionDetails.vue?vue&type=style&index=0&id=35b2a27f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2a27f",
  null
  
)

export default component.exports